<div class="flex flex-col sm:flex-row justify-center gap-6 max-w-[70rem]">

  <app-auth-card
    (submitted)="onLoginInterno()"
    [buttonLabel]="'Acesse sua conta'"
    [message]="'Acesse com seu usuário e senha para adicionar, editar ou encerrar as ocorrências no sistema.'"
    [showButton]="true"
    [showLoading]="false"/>

  <app-auth-card
    (submitted)="onLoginExterno()"
    [buttonLabel]="'Entrar com token'"
    [message]="'Para usuários de concessionárias, acesse via Token'"
    [showButton]="true"
    [showLoading]="false"/>

</div>
